import { StyleSheet } from 'react-native';
import variables from '../../style/themes/default';

export default StyleSheet.create({
  maximum: {
    color: variables.border_color_base,
  },
  minimum: {
    color: variables.brand_primary,
  },
});
